export const youAndDadaPhotos = [
  { id: 1000, album: 'dada', title: '', caption: '', src: '/you and dada/1000408765.jpg' },
  { id: 1001, album: 'dada', title: '', caption: '', src: '/you and dada/1000444548.jpg' },
  { id: 1002, album: 'dada', title: '', caption: '', src: '/you and dada/1000444551.jpg' },
  { id: 1003, album: 'dada', title: '', caption: '', src: '/you and dada/1000444552.jpg' },
  { id: 1004, album: 'dada', title: '', caption: '', src: '/you and dada/1000444553.jpg' },
  { id: 1005, album: 'dada', title: '', caption: '', src: '/you and dada/1000444554.jpg' },
  { id: 1006, album: 'dada', title: '', caption: '', src: '/you and dada/IMG-20260327-WA0005.jpg' },
  { id: 1007, album: 'dada', title: '', caption: '', src: '/you and dada/IMG-20260327-WA0006.jpg' },
  { id: 1008, album: 'dada', title: '', caption: '', src: '/you and dada/IMG-20260327-WA0009.jpg' },
  { id: 1009, album: 'dada', title: '', caption: '', src: '/you and dada/IMG-20260327-WA0010.jpg' },
  { id: 1010, album: 'dada', title: '', caption: '', src: '/you and dada/IMG-20260327-WA0013.jpg' },
  { id: 1011, album: 'dada', title: '', caption: '', src: '/you and dada/IMG-20260327-WA0016.jpg' },
];

